import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useInitContext } from '~/app/providers/InitProvider/hooks/useInitContext';
import { getCatalog } from '~/pages/pay/api/getCatalog/getCatalog';

import { Certificate } from '../ui/PayPage.scheme';
import {
  CERTIFICATES_CONFIG,
  defaultCertificate,
} from '../ui/components/steps/SelectCertificateStep/constants/certificates';

export const useGetCatalog = (
  initError = false,
): {
  certificates: Certificate[];
  loading: boolean;
  isError: boolean;
} => {
  const { loading } = useInitContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['catalog'],
    queryFn: () => getCatalog(),
    enabled: !(loading || initError),
  });

  const certificates: Certificate[] = useMemo(
    () =>
      data
        ? data.map((certificate) => {
            const config = CERTIFICATES_CONFIG?.[certificate.brand.slug];

            return config
              ? ({
                  ...certificate,
                  color: config.color,
                  name: config.name,
                } as Certificate)
              : ({ ...defaultCertificate, ...certificate } as Certificate);
          })
        : [],
    [data],
  );

  return {
    certificates,
    loading: loading || isLoading,
    isError,
  };
};
